import * as React from "react";

/** className joiner without external deps */
function cn(...xs) {
  return xs.filter(Boolean).join(" ");
}

const base =
  "inline-flex items-center justify-center font-medium transition " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900/10 " +
  "disabled:opacity-50 disabled:pointer-events-none rounded-xl";

const variants = {
  default: "bg-slate-900 text-white hover:bg-slate-800 shadow-sm",
  ghost: "bg-transparent hover:bg-slate-100",
  outline:
    "bg-white border border-slate-200 hover:bg-slate-50 text-slate-900 shadow-sm",
};

const sizes = {
  sm: "h-9 px-3 text-sm",
  md: "h-11 px-4 text-sm",
  lg: "h-12 px-5 text-base",
  icon: "h-11 w-11",
};

export const Button = React.forwardRef(
  (
    {
      className,
      variant = "default",
      size = "md",
      isLoading = false,
      children,
      disabled,
      ...props
    },
    ref
  ) => {
    const loading = isLoading || props["aria-busy"] === true;
    return (
      <button
        ref={ref}
        className={cn(base, variants[variant], sizes[size], className)}
        disabled={disabled || loading}
        aria-busy={loading || undefined}
        {...props}
      >
        {loading && (
          <svg
            className={cn(
              "mr-2 h-4 w-4 animate-spin",
              size === "icon" && "mr-0"
            )}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4A4 4 0 008 12H4z"
            />
          </svg>
        )}
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";